namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.CvmSegmentGrid')
    export class CvmSegmentGrid extends Serenity.EntityGrid<CvmSegmentRow, any> {
        protected getColumnsKey() { return CvmSegmentColumns.columnsKey; }
        protected getDialogType() { return CvmSegmentDialog; }
        protected getIdProperty() { return CvmSegmentRow.idProperty; }
        protected getInsertPermission() { return CvmSegmentRow.insertPermission; }
        protected getLocalTextPrefix() { return CvmSegmentRow.localTextPrefix; }
        protected getService() { return CvmSegmentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}